import Dropzone from 'dropzone';

if (document.querySelector("#js-my-form")) {
  let myDropzone = new Dropzone('#js-my-form', {
    paramName: "file",
    maxFilesize: 2,
    createImageThumbnails: false,
    addRemoveLinks: true,
    dictRemoveFile: "",
    accept: function (file: any, done: any) {
      if (file.name == 'sa') {
        done('aa');
      } else {
        done();
      }
    },
  });

  const CheckDefault = () => {
    let addElm: NodeList = document.querySelectorAll('.dz-preview');
    let dropDefault: HTMLElement | null = document.querySelector(
      '.p-form--dropzoon__normal'
    );
    console.log(addElm.length);
    if (dropDefault) {
      if (addElm.length > 0) {
        dropDefault.classList.add('p-form--dropzoon__normal--remove');
      } else {
        dropDefault.classList.remove('p-form--dropzoon__normal--remove');
      }
    }
  }

  myDropzone.on('addedfile', () => {
    CheckDefault();
  });

  myDropzone.on('removedfile', () => {
    CheckDefault();
  })
}


